import React from 'react';
import { components } from 'react-select';
import { getCssVar } from '../../../../../../includes/assets/js/modules/dpitUtilsInc';




export const CustomDropdownIndicator = (
	props,
) => (
	<components.DropdownIndicator {...props}>
		{
			props.selectProps.menuIsOpen
				? <div className="dpit-select-indicator dpit-select-indicator--opened" />
				: <div className="dpit-select-indicator dpit-select-indicator--closed" />
		}
	</components.DropdownIndicator>
);

export const StyleOfSelect = (theme) => {
	let bAdminColor = getCssVar('--dpu-color-3', '34, 113, 177');
	return {
		...theme,
		borderRadius: 2,
		colors: {
			...theme.colors,
			primary25: `rgba(${bAdminColor},0.25)`,
			primary50: `rgba(${bAdminColor},0.55)`,
			primary75: `rgba(${bAdminColor},0.75)`,
			primary: `rgb(${bAdminColor})`,
		},
		spacing: {
			...theme.spacing,
			baseUnit: 4,
			controlHeight: 30,
			menuGutter: 16,
		},
	};
};

